import { render, staticRenderFns } from "./ChinaChart2.vue?vue&type=template&id=2ceedf38&scoped=true"
import script from "./ChinaChart2.vue?vue&type=script&lang=js"
export * from "./ChinaChart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceedf38",
  null
  
)

export default component.exports